import { render, staticRenderFns } from "./ContactInformationForm.vue?vue&type=template&id=f5e5a928"
import script from "./ContactInformationForm.vue?vue&type=script&lang=js"
export * from "./ContactInformationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports